<template>
  <div>
    <Loader v-if="loading" />
    <b-row v-else>
      <b-col cols="12" md="4">
        <div class="card mb-3 p-3">
          <div class="section-title">موضوع</div>
          <Radio :componentData="packageCategories" :value="model.packageCategoryId" @input="model.packageCategoryId = $event" />
        </div>
        <div class="card p-3 mt-3 my-auto d-flex flex-column justify-content-between">
          <div>
            <b-form-checkbox v-model="model.isDiplayable" class="pt-2">
              <div class="mx-1">نمایش در صفحه خانه</div>
            </b-form-checkbox>
          </div>
          <div>
            <b-form-checkbox v-model="model.isEnable" class="pt-2">
              <div class="mx-1">نمایش بسته</div>
            </b-form-checkbox>
          </div>

          <div class="d-flex justify-content-between">
            <b-form-checkbox v-model="model.isRecommended" class="pt-2">
              <div class="mx-1">بسته پیشنهادی</div>
            </b-form-checkbox>
            <b-button @click="$bvModal.show('deleteModal')" variant="outline-secondary">
              <i class="far fa-times-circle"></i>
              <span class="ms-2">حذف دوره</span>
            </b-button>
          </div>
        </div>

        <div class="card p-3 mt-3">
          <BaseText :maxlength="2000" v-model="model.order" title="ترتیب بسته های پیشنهادی" placeholder="ترتیب بسته های پیشنهادی" class="mt-2" />
        </div>
        <div class="inner__style mt-3">
          <div v-if="images.length === 0" class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center" @click="$bvModal.show('cropperModal')">
            <div>
              <i class="fas fa-cloud-upload-alt icon-size"></i>
              <div class="upload-text-size">عکس بسته را انتخاب کنید</div>
            </div>
          </div>
          <div v-else class="grand-parent">
            <div class="uploaded-photo-main">
              <div v-for="(image, index) in images" :key="index" class="uploaded-photo">
                <div class="remove-icon" @click="removeImage({ index, image })">
                  <i class="fa fa-times"></i>
                </div>
                <img class="previewImage" @click="changeSelectedImage(image)" :src="image" :class="{ selected: model.selectedImage == image }" />
              </div>
              <div v-if="images.length < 2" @click="$bvModal.show('cropperModal')" class="uploaded-photo addNewImageIconContainer">
                <i class="fa fa-plus"></i>
              </div>
            </div>
          </div>
          <div class="my-3">
            <TextAreaInput
              :maxlength="100"
              :value="model.selectedImageAlternateText"
              @input="model.selectedImageAlternateText = $event"
              title="متن جایگزین 1"
              placeholder="متن جایگزین"
              rows="2"
            />
          </div>
          <div class="my-3">
            <TextAreaInput rows="2" :maxlength="100" :value="model.imageAlternateText" @input="model.imageAlternateText = $event" title="متن جایگزین 2" placeholder="متن جایگزین" />
          </div>
        </div>
        <div class="inner__style my-3">
          <div
            v-if="!model.video"
            class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
            @click="
              $bvModal.show('videoModal')
              cropperLoading = false
            "
          >
            <div>
              <i class="fas fa-cloud-upload-alt icon-size"></i>
              <div class="upload-text-size">ویدئو تبلیغاتی بسته را انتخاب کنید</div>
            </div>
          </div>
          <div v-else class="grand-parent">
            <div class="upload-photo-parent">
              <div class="uploaded-video">
                <div
                  class="remove-icon"
                  @click="
                    model.video = ''
                    uploadedvideo = ''
                  "
                >
                  <i class="fa fa-times"></i>
                </div>
                <video class="previewVideo" :src="model.video" />
              </div>
            </div>
          </div>
          <div class="my-3">
            <BaseText :maxlength="2000" :value="model.videoName" @input="model.videoName = $event" title="نام ویدئو" placeholder="نام ویدئو" />
          </div>
        </div>

        <div class="inner__style my-3">
          <div
            v-if="!model.summaryVideo"
            class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
            @click="
              $bvModal.show('videoSummaryModal')
              cropperLoading = false
            "
          >
            <div>
              <i class="fas fa-cloud-upload-alt icon-size"></i>
              <div class="upload-text-size">خلاصه ویدئو بسته را انتخاب کنید</div>
            </div>
          </div>
          <div v-else class="grand-parent">
            <div class="upload-photo-parent">
              <div class="uploaded-video">
                <div
                  class="remove-icon"
                  @click="
                    model.summaryVideo = ''
                    uploadedsummaryvideo = ''
                  "
                >
                  <i class="fa fa-times"></i>
                </div>
                <video class="previewVideo" :src="model.summaryVideo" />
              </div>
            </div>
          </div>
          <div class="my-3">
            <BaseText :maxlength="2000" :value="model.summaryVideoName" @input="model.summaryVideoName = $event" title="نام ویدئو" placeholder="نام ویدئو" />
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="8">
        <div class="card">
          <Section title="اطلاعات بسته">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.title" @input="model.title = $event" title="عنوان بسته" placeholder="عنوان بسته" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.shortDescription" @input="model.shortDescription = $event" title="توضیحات کوتاه" placeholder="توضیحات کوتاه" />
            </div>
            <div class="my-3">
              <EditorInput :value="model.fullDescription" @input="model.fullDescription = $event" title="توضیحات کلی" textAreaClass="align-items-center" />
            </div>
          </Section>
        </div>
        <div class="card">
          <div class="date-header">اطلاعات بسته</div>
          <Section title="وضعیت بسته">
            <div class="my-3">
              <BaseText
                inputType="number"
                :maxlength="2000"
                :value="+model.onlinePercentage"
                @input="model.onlinePercentage = $event"
                title="درصد آنلاین"
                placeholder="درصد آنلاین"
              />
            </div>
            <div class="my-3">
              <BaseText
                inputType="number"
                :maxlength="2000"
                :value="+model.offlinePercentage"
                @input="model.offlinePercentage = $event"
                title="درصد آفلاین"
                placeholder="درصد آفلاین"
              />
            </div>
            <div class="my-3">
              <BaseText
                inputType="number"
                :maxlength="2000"
                :value="+model.inclassPercentage"
                @input="model.inclassPercentage = $event"
                title="درصد حضوری"
                placeholder="درصد حضوری"
              />
            </div>
            <Radio :componentData="cuorseTypes" :value="model.packageType" @input="model.packageType = $event" class="package-type" />
          </Section>
          <Section title="تعداد جلسات">
            <div>
              <BaseText :maxlength="2000" :value="model.numberOfSessions" @input="model.numberOfSessions = $event" title="تعداد جلسات" placeholder="تعداد جلسات" />
            </div>
          </Section>
          <Section title="مدت دوره">
            <div>
              <BaseText :maxlength="2000" :value="model.duration" @input="model.duration = $event" title="مدت دوره" placeholder="مدت دوره" />
            </div>
          </Section>
          <Section v-if="!model.packageType || model.packageType === 0 || model.packageType === 1" title="تاریخ بسته">
            <div>
              <DateTimeOffset range :value="dateRange" @input="dateRange = $event" title="تاریخ بسته" placeholder="تاریخ بسته" :hasDefaultDate="false" :key="dateRender" />
            </div>
          </Section>
          <Section>
            <div>
              <DateTimeOffset :value="model.hour" @input="model.hour = $event" title="ساعت شروع دوره" placeholder="ساعت شروع دوره" :hasDefaultDate="false" type="time" />
            </div>
          </Section>
          <Section v-if="(!model.packageType || model.packageType === 2) && model.packageType !== 0" title="تاریخ انتشار">
            <div>
              <DateTimeOffset
                :value="model.releaseDatetime"
                @input="model.releaseDatetime = $event"
                title="تاریخ انتشار"
                placeholder="تاریخ انتشار"
                :hasDefaultDate="false"
                :key="dateRender"
              />
            </div>
          </Section>
          <Section title="مدرک">
            <ComboBox
              :searchedData="packageCertificates"
              title="اعطا گواهی معتبر"
              placeholder="اعطا گواهی معتبر"
              :selectedValue="selectedCertificate"
              @select="fillSelectedCertificate"
              :inputStyle="comboStyle"
            />
          </Section>
          <Section title="ظرفیت">
            <div>
              <CountInput :value="model.capacity" @input="model.capacity = $event" title="ظرفیت" placeholder="ظرفیت" />
            </div>
          </Section>
          <Section title="مهلت ثبت نام">
            <div>
              <DateTimeOffset
                :value="model.deadlineDate"
                @input="model.deadlineDate = $event"
                title="مهلت ثبت نام"
                placeholder="مهلت ثبت نام"
                :hasDefaultDate="false"
                :key="dateRender"
              />
            </div>
          </Section>
          <Section title="توضیحات تکمیلی">
            <div>
              <EditorInput :value="model.extraDescription" @input="model.extraDescription = $event" title="توضیحات تکمیلی" :hasImage="false" textAreaClass="align-items-center" />
            </div>
          </Section>
          <Section title="خرید نقدی">
            <div class="d-flex justify-content-between">
              <div class="w-50">
                <BaseText :maxlength="2000" :value="model.price" @input="model.price = $event" title="قیمت" placeholder="قیمت (تومان) " />
              </div>
              <div class="w-50 ms-4">
                <BaseText :maxlength="2000" :value="model.dicount" @input="model.dicount = $event" title="قیمت با تخفیف" placeholder="قیمت با تخفیف (تومان) " />
              </div>
            </div>
          </Section>
          <Section title="خرید اقساطی">
            <Dragable :items="model.installmentPayments" draggable=".drag">
              <div v-for="(item, index) in filterPeyments" :key="index" class="d-flex justify-content-between mb-4" style="cursor: move" :class="{ drag: item.validDate }">
                <div class="part">
                  <strong class="me-3">قسط{{ index + 1 }}</strong>
                  <div class="w-100">
                    <BaseText :maxlength="2000" :value="item.price" @input="item.price = $event" labelClass="label-no-width" title="مبلغ" placeholder="مبلغ (تومان) " />
                  </div>
                </div>
                <div class="w-50 ms-4">
                  <DateTimeOffset :value="item.validDate" @input="item.validDate = $event" title="تاریخ پرداخت" placeholder="تاریخ پرداخت" :hasDefaultDate="false" />
                </div>
              </div>
            </Dragable>
          </Section>
          <div class="card">
            <Section title="تنظیمات سئو">
              <div class="my-3">
                <Tags title="کلیدواژه" :value="model.seoKeyword" classes="tags" @input="model.seoKeyword = $event" placeholder="کلیدواژه" />
              </div>
              <div class="my-3">
                <TextAreaInput :value="model.seoDescription" @input="model.seoDescription = $event" title="توضیحات" textAreaClass="align-items-center" />
              </div>
              <div class="my-3">
                <BaseText :maxlength="2000" :value="model.seoUrlDescription" @input="model.seoUrlDescription = $event" title="متن URL" placeholder="متن URL" />
              </div>
            </Section>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button @click="$router.push('/list/packages')">انصراف</b-button>
      <b-button variant="primary ms-2 px-5" @click="addPackage">ثبت</b-button>
    </div>
    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">آیا از حذف بسته اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('deleteModal')">خیر</b-button>
            <b-button class="ms-2 col-6" variant="primary" block @click="deletePackage">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <Toast :title="message" :error="error" :showToast="message !== ''" />
    <b-modal id="cropperModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
      <template #modal-title>کراپ عکس</template>
      <div class="p-3">
        <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="uploadImage($event)" :cropSize="imageCrop" cropShape="rectangle-stencil">
          <template v-if="images.length <= 0">
            <div class="my-3">
              <BaseText
                :maxlength="100"
                :value="model.selectedImageAlternateText"
                @input="model.selectedImageAlternateText = $event"
                title="متن جایگزین"
                placeholder="متن جایگزین"
              />
            </div>
          </template>
          <template v-else>
            <div class="my-3">
              <BaseText :maxlength="100" :value="model.imageAlternateText" @input="model.imageAlternateText = $event" title="متن جایگزین" placeholder="متن جایگزین" />
            </div>
          </template>
        </ImageCropper>
      </div>
    </b-modal>
    <b-modal id="videoModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title no-close-on-backdrop @close="closeVideoUpload('video')">
      <template #modal-title>انتخاب ویدئو</template>
      <div class="p-3">
        <VideoUpload
          @preload="preload($event, 'video')"
          :percent="percentCompleted"
          :loading="cropperLoading"
          @videoSourceChanged="uploadVideo($event, 'video')"
          @close="closeVideoUpload('video')"
        />
      </div>
    </b-modal>
    <b-modal
      id="videoSummaryModal"
      no-close-on-esc
      hide-footer
      centered
      size="md"
      header-close-variant="dark"
      cancel-title
      no-close-on-backdrop
      @close="closeVideoUpload('summaryVideo')"
    >
      <template #modal-title>انتخاب ویدئو</template>
      <div class="p-3">
        <VideoUpload
          @preload="preload($event, 'summaryVideo')"
          :percent="percentCompleted"
          :loading="cropperLoading"
          @videoSourceChanged="uploadVideo($event, 'summaryvideo')"
          @close="closeVideoUpload('summaryVideo')"
        />
      </div>
    </b-modal>
  </div>
</template>
<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import fileMannager from '../../../services/file'
import dadbanPackagesProvider from '../../../services/dadban/package'
import Toast from '../../common/Toast.vue'
import Loader from '../../widgets/loader.vue'
import ImageCropper from '../../user/ImageCropper.vue'
import Section from '../../common/form/Section.vue'
import Radio from '../../common/form/formModules/Radio.vue'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
import VideoUpload from '../../common/form/VideoUpload.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import EditorInput from '../../common/form/formModules/editorInput.vue'
import Dragable from '../../common/Dragable.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import Tags from '../../common/form/formModules/Tags.vue'
import CountInput from '../../common/form/CountInput.vue'
import axios from 'axios'

let controller = new AbortController()
export default {
  name: 'AddPackage',
  components: { CountInput, Toast, Loader, ImageCropper, Section, BaseText, Radio, DateTimeOffset, VideoUpload, ComboBox, EditorInput, Dragable, TextAreaInput, Tags },
  props: {
    create: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        title: '',
        description: '',
        extraDescription: '',
        onlinePercentage: 0,
        offlinePercentage: 0,
        releaseDatetime: '',
        inclassPercentage: 0,
        numberOfSessions: '',
        duration: '',
        startDate: '',
        endDate: '',
        releaseDate: '',
        packageType: '',
        hour: '',
        fullDescription: '',
        price: '',
        dicount: '',
        order: undefined,
        isDiplayable: true,
        isEnable: true,
        isRecommended: false,
        selectedImage: '',
        image: '',
        video: '',
        hasCertificate: false,
        videoName: '',
        summaryVideo: '',
        summaryVideoName: '',
        packageCategoryId: '',
        courseCertificateId: '',
        seoKeyword: [],
        seoDescription: '',
        seoUrlDescription: '',
        selectedImageAlternateText: '',
        selectedImageDescription: '',
        imageAlternateText: '',
        imageDescription: '',
        deadlineDate: '',
        capacity: '',
        installmentPayments: [
          {
            price: '',
            validDate: '',
          },
        ],
      },
      comboStyle: 'color: #495057',
      selectedCertificate: '',
      packageCategories: [],
      packageCertificates: [],
      dateRange: [],
      message: '',
      cropperLoading: false,
      submit: false,
      error: false,
      loading: false,
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت بسته', active: true },
      ],
      imageCrop: { width: 400, height: 200 },
      images: [],
      updateForm: false,
      dateRender: true,
      percentCompleted: 0,
      uploadedvideo: '',
      uploadedsummaryvideo: '',
      cuorseTypes: [
        {
          value: 'آنلاین',
          key: 1,
        },
        {
          value: 'آفلاین',
          key: 2,
        },
        {
          value: 'حضوری',
          key: 0,
        },
      ],
    }
  },
  computed: {
    filterPeyments() {
      return this.model.installmentPayments.map((item) => {
        if (item.price) {
          item.price = item.price.toString()
          item.price = item.price.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
        return item
      })
    },
    checkLastPaymentDate() {
      const last = this.model.installmentPayments.length - 1
      return this.model.installmentPayments[last].validDate
    },
    checkLastPaymentprice() {
      const last = this.model.installmentPayments.length - 1
      return this.model.installmentPayments[last].price
    },
  },
  watch: {
    'model.deadlineDate'(c) {
      if (!c.includes('T') && c) {
        this.model.deadlineDate = this.model.deadlineDate.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
    'model.releaseDatetime'(c) {
      if (!c.includes('T') && c) {
        this.model.releaseDatetime = this.model.releaseDatetime.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
    checkLastPaymentDate(c) {
      if (c && !this.submit) {
        this.model.installmentPayments.push({
          price: '',
          validDate: '',
        })
      }
    },
    checkLastPaymentprice(c) {
      const last = this.model.installmentPayments.length - 1
      const item = this.model.installmentPayments[last].price
      if (item === c && !this.submit) {
        this.model.installmentPayments[last].price = item.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'model.price'(c) {
      if (c && !this.submit) {
        this.model.price = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'model.dicount'(c) {
      if (c && !this.submit) {
        this.model.dicount = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    dateRange(c) {
      if (c.length > 1) {
        const start = c[0]
        const end = c[1]
        this.model.startDate = start.replaceAll('/', '-') + 'T00:00:00.000Z'
        this.model.endDate = end.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
      if (c.length === 1) {
        this.model.startDate = c[0].replaceAll('/', '-') + 'T00:00:00.000Z'
      }

      if (!c) {
        this.model.startDate = null
        this.model.endDate = null
      }
    },
    'images.length'(c) {
      const selected = this.images[0]
      if (c <= 1) {
        if (!this.model.selectedImage && this.images.length) {
          this.model.selectedImage = selected
        }
      }
    },
    filterPeyments() {
      this.model.installmentPayments.forEach((item, index) => {
        item.order = index
      })
    },
  },
  async mounted() {
    await this.fetchPackageInputs()
    if (this.update) {
      this.fetchPackage(+this.$route.params.packageId)
    }
    this.loading = false
    setTimeout(() => {
      this.dateRender = false
    }, 3000)
  },
  methods: {
    async addPackage() {
      this.loading = true
      this.model.image = this.images.find((item) => item !== this.model.selectedImage)

      if (this.dateRange.length === 1) {
        this.model.endDate = this.model.startDate
      }

      this.model.video = this.uploadedvideo
      this.model.summaryVideo = this.uploadedsummaryvideo
      try {
        if (this.update) {
          this.checkData()
          const req = await dadbanPackagesProvider.updatePackage({ ...this.model, order: Number(this.model.order) })
          if (req.status === 200) {
            this.$emit('update', !this.updateForm)
            this.loading = false
          } else {
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          return false
        }
        if (!this.model.price && !this.model.dicount) {
          this.model.price = 0
          this.model.dicount = 0
        }
        this.checkData()
        const req = await dadbanPackagesProvider.addPackage({ ...this.model, order: Number(this.model.order) })
        if (req.status === 200) {
          this.$router.push('/list/packages/detail/' + req.data.data)
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async fetchPackage() {
      this.loading = true
      try {
        if (this.update) {
          const req = await dadbanPackagesProvider.getPackage(+this.$route.params.packageId)
          this.model = req.data.data.output

          if (this.model?.installmentPayments?.length) {
            this.model.installmentPayments.sort((a, b) => a.order - b.order)
          }

          if (!this.model?.installmentPayments?.length) {
            this.model.installmentPayments = [
              {
                price: '',
                validDate: '',
              },
            ]
          }
          this.uploadedvideo = this.model.video
          this.uploadedsummaryvideo = this.model.summaryVideo
          if (this.model.selectedImage) {
            this.images.push(this.model.selectedImage)
          }
          if (this.model.image) {
            this.images.push(this.model.image)
          }
          if (this.model.price) {
            this.model.price = this.model.price.toString()
          }
          if (this.model.dicount) {
            this.model.dicount = this.model.dicount.toString()
          }
          if (this.model.startDate) {
            this.dateRange[0] = this.model.startDate.slice(0, 10).replaceAll('-', '/')
          }
          if (this.model.endDate) {
            this.dateRange[1] = this.model.endDate.slice(0, 10).replaceAll('-', '/')
          }
          this.packageCertificates.filter((item) => {
            if (item.key === this.model.courseCertificateId) {
              this.selectedCertificate = item.value
            }
          })
          for (const key of this.model) {
            if (this.model[key] === null) {
              this.model[key] = ''
            }
          }
        }

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async fetchPackageInputs() {
      this.loading = true
      const req = await dadbanPackagesProvider.getInputs()
      req.data.data.output.categories.forEach((item) => {
        this.packageCategories.push({ value: item.name, key: item.id })
      })

      req.data.data.output.certificates.forEach((item) => {
        this.packageCertificates.push({ value: item.name, key: item.id })
      })
    },
    async uploadImage(e) {
      this.cropperLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })
      this.images.push(req.data.data.downloadUrl)
      this.cropperLoading = false
      this.$bvModal.hide('cropperModal')
    },
    removeImage(payload) {
      this.images.splice(payload.index, 1)
      if (payload.image === this.model.image) {
        this.model.image = ''
      }
      if (payload.image === this.model.selectedImage) {
        this.model.selectedImage = ''
      }
      this.changeSelectedImage(payload.image)
    },
    async uploadVideo(e, item) {
      try {
        this.cropperLoading = true
        const req = await axios.post('FileManager/api/File/AddFiles', e, {
          onUploadProgress: (progressEvent) => {
            this.percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          },
          signal: controller.signal,
        })
        this['uploaded' + item] = req.data.data[0].downloadUrl
        setTimeout(() => {
          this.percentCompleted = 0
          this.$bvModal.hide('videoModal')
          this.$bvModal.hide('videoSummaryModal')
        }, 2000)
      } catch (error) {
        this.cropperLoading = false
      }
      this.cropperLoading = false
    },
    closeVideoUpload(item) {
      this.$bvModal.hide('videoModal')
      this.$bvModal.hide('videoSummaryModal')
      controller.abort()
      controller = new AbortController()
      this.percentCompleted = 0
      this.model[item] = ''
      this.model[item + 'Name'] = ''
    },
    preload(e, item) {
      this.model[item] = e
    },
    async deletePackage() {
      this.loading = true
      try {
        const req = await dadbanPackagesProvider.deletePackage(+this.$route.params.packageId)
        this.$bvModal.hide('deleteModal')
        if (req.status === 200) {
          this.$router.push('/list/packages' + localStorage.getItem('query'))
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    addCertificate(e) {
      this.model.courseCertificateId = e.key
    },
    fillSelectedCertificate(e) {
      if (!e) {
        this.model.courseCertificateId = null
        this.model.hasCertificate = false
        return false
      }
      this.model.courseCertificateId = this.packageCertificates.find((item) => item.value === e).key
      this.model.hasCertificate = true
    },
    checkData() {
      this.submit = true
      for (const key in this.model) {
        if (this.model[key] === '' || this.model[key] === undefined || this.model[key] === null) {
          delete this.model[key]
        }
      }
      if (this.model.price) {
        this.model.price = this.model.price.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.price = +this.model.price
      }
      if (this.model.dicount) {
        this.model.dicount = this.model.dicount.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.dicount = +this.model.dicount
      }
      this.model.offlinePercentage = +this.model.offlinePercentage || 0
      this.model.onlinePercentage = +this.model.onlinePercentage || 0
      this.model.inclassPercentage = +this.model.inclassPercentage || 0
      this.model.installmentPayments.forEach((item) => {
        const empty = this.model.installmentPayments.findIndex((item) => item.price === '')
        if (!item.price || !item.validDate) {
          this.model.installmentPayments.splice(empty, 1)
        }
        item.validDate = !item.validDate.includes('T') ? item.validDate.replaceAll('/', '-') + 'T00:00:00.000Z' : item.validDate
        if (item.price && item.price !== '') {
          item.price = item.price.replace(/[^a-zA-Z0-9 ]/g, '')
          item.price = +item.price
        }
      })
    },
    installmentPaymentsMove(e) {
      console.log(e)
    },
    changeSelectedImage(image) {
      if (this.model.selectedImage !== image) {
        this.model.selectedImage = image
        const imageDescription = this.model.selectedImageDescription
        const imageAlternateText = this.model.selectedImageAlternateText
        this.model.selectedImageAlternateText = this.model.imageAlternateText
        this.model.selectedImageDescription = this.model.imageDescription
        this.model.imageDescription = imageDescription
        this.model.imageAlternateText = imageAlternateText
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

video {
  width: 100%;
}

.uploaded-video {
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo {
  height: 120px;
  width: 160px;
  position: relative;
  margin-left: 10px;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  z-index: 1;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    color: #ff4861;
  }
}
.previewImage {
  border-radius: 4px;
}
.previewVideo {
  border-radius: 4px;
  width: 100%;
}

.checkbox-margin {
  margin-right: 8px;
}

.section-title {
  font-size: 16px;
}
::v-deep .custom-control-label {
  margin-right: 10px !important;
}

::v-deep .custom-control-input {
  border: 1px solid #556ee6 !important;
}

::v-deep .text-muted {
  display: none;
}

.date-header {
  font-size: 17px;
  margin: 16px;
}

.part {
  display: inline-flex;
  width: 50%;
  strong {
    margin-left: 18px;
    display: flex;
    align-items: center;
  }
}

.uploaded-photo-main {
  display: flex;
  flex-wrap: wrap;
}

.selected {
  border: 3px solid #556be6;
}

::v-deep .b-form-tags-button {
  display: none;
}

.package-type {
  ::v-deep .bv-no-focus-ring {
    display: flex !important;
  }
  ::v-deep .custom-control {
    margin-left: 20px !important;
  }
}
</style>
